import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/configStore'
import { Provider } from "react-redux";
//Cấu hình realtime (websocket với signalR)
// import * as signalR from '@aspnet/signalr'

//antd
// import "antd/dist/antd.css";
import 'antd/dist/antd.min.css';

//Import đa ngôn ngữ
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Provider store={store}>
    <App />
  </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
